export default {
      id: "Icon--badgePhotographed-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--badgePhotographed",
      toString: function () {
        return this.url;
      }
    }